import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { scrollToElem } from 'cityads-v3/utils/htmlUtils';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Scrollspy from 'react-scrollspy';
import Sticky from 'react-stickynode';

import classes from './MenuSpy.scss';

@connect(state => ({
  isMobile: state.app.isMobile
}))
export default class MenuSpy extends Component {

  static propTypes = {
    items               : PropTypes.array,
    sticky              : PropTypes.bool,
    stickyTop           : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    stickyBottomBoundary: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    offset              : PropTypes.number,
  };

  static defaultProps = {
    stickyTop           : '#header',
    stickyBottomBoundary: '#content',
  };

  state = {
    currentItem: null
  }

  onUpdate = elem => {
    const currentItem = elem && elem.id;
    this.setState({
      currentItem
    });
  }

  onClick = key => {
    if (!document) { return null; }

    const elem = document.getElementById(key);
    return evt => {
      evt.preventDefault();
      scrollToElem(elem, this.props.offset);
    }
  }

  handleBottomNavigation = (evt, value) => {
    this.onClick(value)(evt);
  }

  renderScrollSpy() {
    const { items, offset, isMobile } = this.props;
    const { currentItem } = this.state;

    return (
      <Scrollspy
        items        = {items.map(item => item.key)}
        componentTag = "div"
        offset       = {offset}
        onUpdate     = {this.onUpdate}
        className    = {classes.root}
      >
        {isMobile ? (
          <BottomNavigation value={currentItem} onChange={this.handleBottomNavigation} className={classes.bottomNavigation}>
            {items.map(item => (
              <BottomNavigationAction key={item.key} value={item.key} icon={item.icon} />
            ))}
          </BottomNavigation>
        ) :
          items.map(item => (
            <ListItem
              key={item.key}
              onClick={this.onClick(item.key)}
              sx={{ p: 0 }}
            >
              <ListItemButton>
                {item.icon && (
                  <ListItemIcon
                    classes={{
                      root: classNames(classes.listIcon, {
                        [classes.active]: currentItem === item.key
                      })
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                )}

                <ListItemText
                  primary={item.title}
                  classes={{
                    primary: classNames({
                      [classes.active]: currentItem === item.key
                    })
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))
        }
      </Scrollspy>
    )
  }

  render() {
    const { sticky, isMobile, stickyTop, stickyBottomBoundary } = this.props;

    return sticky && !isMobile ? (
      <Sticky
        enabled        = {true}
        top            = {stickyTop}
        bottomBoundary = {stickyBottomBoundary}
      >
        {this.renderScrollSpy()}
      </Sticky>
    ) : this.renderScrollSpy();
  }

}
